import React from 'react'
import PortfolioCardComp from './Component/PortfolioCardComp'

const Portfolio = () => {
  return (
    <div >
      <PortfolioCardComp/>

    </div>
  )
}

export default Portfolio
